import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnInit } from '@angular/core';
import * as moment from 'moment';
import { element } from 'protractor';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { Store } from 'src/app/core/store/store';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        overflow: 'hidden',
        height: '*',
        width: '100%'
      })),
      state('out', style({
        overflow: 'hidden',
        height: '250px',
        width: '100%'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ]
})
export class DashboardComponent implements OnInit {
  public dropDownData: any = [
    { name: 'Completion: high to low', value: 'COMPLETION_HIGH_TO_LOW' },
    { name: 'Completion: low to high', value: 'COMPLETION_LOW_TO_HIGH' },
    { name: 'Score: high to low', value: 'SCORE_HIGH_TO_LOW' },
    { name: 'Score: low to high', value: 'SCORE_LOW_TO_HIGH' },
    { name: 'Last Login (Ascending)', value: 'LOGIN_TIME_RECENT' },
    { name: 'Last Login (Descending)', value: 'LOGIN_TIME_LEAST' },
    { name: 'Time Spent: high to low', value: 'TIME_SPENT_HIGH_TO_LOW' },
    { name: 'Time Spent: low to high', value: 'TIME_SPENT_LOW_TO_HIGH' },
  ];
  selectedValue: any = 'Last Login (Descending)';
  pageSize = 10;
  pageNumber = 1;
  totalRating = 4.5;
  page: any;
  whiteColor = '#fff';
  openDiv: string;
  innerWidth: any;
  cellstoshow = 4;
  metrics: any;
  learners: any;
  elements: any;
  engagementHealthColor = '#E1E1E1';
  scoreHealthColor = '#ED6B4D';
  ratingHealthColor = '#ED6B4D';
  engagementHealth = 0;
  scoresHealth = 0;
  ratingsHealth = 0;
  avgScore = 0;
  avgProgress = 0;
  toolTipeIcon = `&#9432;`;
  currentOrganization = '';
  currentActivation = '';
  progress = [0, 0, 0, 0, 0, 0];
  avgTimeSpent = {
    totalTime : 0,
    count: 0
  };
  learnerMap = {};
  todaysDate: any = new Date();
  date = new Date();
  engagmentDataPoints = true;
  userTimezone: any;
  public typeTitle = {
    PRE: 'Pre Assessment',
    MASTERCLASS: 'Masterclass',
    COURSE: 'Course',
    POST: 'Post Assessment',
    ASSESSMENT : 'Assessment'
  };
  assessments = 0;
  totalHours = 0;

  sortCriteriaMap: any = {
    COMPLETION_HIGH_TO_LOW: (a, b) => (a.progress > b.progress) ? -1 : (a.progress < b.progress) ? 1 : 0,
    COMPLETION_LOW_TO_HIGH: (a, b) => (a.progress > b.progress) ? 1 : (a.progress < b.progress) ? -1 : 0,
    SCORE_HIGH_TO_LOW: (a, b) => (a.programpercentage > b.programpercentage) ? -1 : (a.programpercentage < b.programpercentage) ? 1 : 0,
    SCORE_LOW_TO_HIGH: (a, b) => (a.programpercentage > b.programpercentage) ? 1 : (a.programpercentage < b.programpercentage) ? -1 : 0,
    LOGIN_TIME_RECENT: (a, b) => (a.days > b.days) ? 1 : (a.days < b.days) ? -1 : 0,
    LOGIN_TIME_LEAST: (a, b) => (a.days > b.days) ? -1 : (a.days < b.days) ? 1 : 0,
    TIME_SPENT_LOW_TO_HIGH: (a, b) => this.learnerMap[a.email].timeSpent - this.learnerMap[b.email].timeSpent,
    TIME_SPENT_HIGH_TO_LOW: (a, b) => this.learnerMap[b.email].timeSpent - this.learnerMap[a.email].timeSpent,
  };
  filteredUsers: any[];

  constructor(private partnerService: PartnerService, private store: Store, private datePipe: DatePipe) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1024 && this.innerWidth >= 768) {
      this.cellstoshow = 3;
    } else if (this.innerWidth <= 767 && this.innerWidth >= 481) {
      this.cellstoshow = 2;
    } else if (this.innerWidth <= 480) {
      this.cellstoshow = 1.5;
    }
    this.todaysDate = this.todaysDate.getTime();
  }


  ngOnInit(): void {
    this.openDiv = 'out';
    this.store.select<any>('metrics').subscribe((metrics) => {
      this.engagmentDataPoints = true;
      this.page = 1;
      this.metrics = metrics;
      this.avgProgress = 0;
      this.avgScore = 0;

      /*
      *  For each learner, sanitize the data as per what is required in the UI
      *  Ex: Combine first name and last name to make it a name field. Have a very high value if they have not logged in etc.
      *  Do a default sort on completion rate of the program
      *
      *
      *
      */

      this.learners = metrics?.learners ? metrics.learners.map((l) => {
        return {
          ...l,
          name: l.firstname && l.lastname ? `${l.firstname} ${l.lastname}` : l.firstname ? l.firstname : l.lastname,
          programpercentage: l.programpercentage ? Math.floor(l.programpercentage.toFixed(1)) : 0,
          progress: l.progress ? Math.floor(l.progress.toFixed(1)) : 0,
          days: l.daysSinceLogin < 0 ? 1000000 : l.daysSinceLogin,
        };
      }).sort(this.sortCriteriaMap.LOGIN_TIME_LEAST) : [];
      this.filterUsers();
      let totalScore = 0, totalScoreCount = 0;
      let totalProgress = 0;

    /*
      *  Calculate the avg scores
      *
      *  1. Consider scores only if the progress > 0
      *  2. Average progress is the total progress divided by the number of learners
      *
      *
      *
      */
      this.learners.forEach((l) => {
          if (l.programpercentage && l.programpercentage > 0){
            totalScore = totalScore + l.programpercentage;
            totalScoreCount = totalScoreCount + 1;

          }
          totalProgress = totalProgress + l.progress;
      });

      if (this.learners.length > 0){
        this.avgProgress = Math.floor(totalProgress / this.learners.length);
        this.avgScore = totalScoreCount > 0 ? Math.floor(totalScore / totalScoreCount) : 0;
      }

      let healthOfRatings = 0;
      let totalMasterClasses = 0;
      let totalCourses = 0;
      let healthOfScores = 0;
      let healthOfScoresCount = 0;
      let healthOfRatingsCount = 0;

      this.scoresHealth = 0;
      this.ratingsHealth = 0;
      this.engagementHealth = 0;

       /*
      *  Calculate the element card data for the UI
      *
      *  1. At each element level, calculate the stats
      *  2. Calculate UI-level display data like average rating for element, locked or unlocked status,
      *  average score, people in each stage of completed, in progress or not started
      *  3. Calculate numerators for the health cards
      *
      *
      *
      */

      this.assessments = 0;
      let minsToBeAdded = 0;
      this.store.select<string>('userTimeZone').pipe(distinctUntilChanged()).subscribe((timezone) => {
        this.userTimezone = timezone;
      });
      this.elements = metrics?.elements ? metrics.elements.map((e, index) => {
        if (e?.title !== '') {
          if (typeof e?.startDate == 'string' && e?.startDate?.includes(' - Default')){
            const pattern = /( \- Default)/g;
            e.startDate = this.datePipe.transform(e.startDate.replace(pattern, ''), 'd MMM y');
          }
          if (e.type === 'PRE' || e.type === 'POST' || e.type === 'ASSESSMENT'){
            this.assessments = this.assessments + 1;
          }

          if (e.type === 'ASSESSMENT'){
            minsToBeAdded = minsToBeAdded + 30;
          }

          if (e.type === 'COURSE' || e.type === 'MASTERCLASS') {
            healthOfRatings = healthOfRatings + e.totalRatings;
            healthOfRatingsCount = healthOfRatingsCount + e.totalRatingCount;
          }

          if (e.type === 'COURSE') {
            healthOfScores = healthOfScores + e.totalScore;
            const completedScores = e.totalScore > 0 ? e.completed : 0;
            healthOfScoresCount = healthOfScoresCount + completedScores;
            totalCourses = totalCourses + 1;
          }

          if (e.type === 'MASTERCLASS') {
            totalMasterClasses = totalMasterClasses + 1;
          }
          return {
            ...e, startDateString: e.startDate ? (e.type === 'MASTERCLASS' ? this.datePipe.transform(e?.startDate, 'd MMM y') : this.getLongDateStringWithoutTime(e.startDate)) : '', startDate: e.startDate ? parseInt(e.startDate) : 0,
            past: !this.isInt(e.startDate) || parseInt(e.startDate) < moment().valueOf(),
            avgRating: e.totalRatingCount > 0 ? (e.totalRatings / e.totalRatingCount).toFixed(1) : 'NA',
            avgScore: e.totalScoreCount > 0 ? Math.floor(e.totalScore / e.completed) : 'NA',
            completedPercent: Math.ceil(e.completed * 100 / (e.completed + e.inProgress + e.notStarted)),
            inProgressPercent: Math.ceil(e.inProgress * 100 / (e.completed + e.inProgress + e.notStarted)),
            notStartedPercent: Math.ceil(e.notStarted * 100 / (e.completed + e.inProgress + e.notStarted)),

          };

        }

      }) : [];
      const filteredArray = this.elements.filter(element => element !== undefined);
      this.elements = filteredArray;
       /*
      *  Calculate the health widgets
      *
      *  1. Engagement Health:
      *  2. Scores Health
      *  3. Ratings Health
      *
      *  4. Assign colors to the health scores based on the spec
      *
      *
      *
      */

      if (this.learners?.length > 0) {
        const learnerCount = this.learners.length;
        this.scoresHealth = healthOfScoresCount > 10 ? Math.ceil(healthOfScores / healthOfScoresCount) : 0;
        this.ratingsHealth = healthOfRatingsCount > 10 ? Math.ceil(healthOfRatings * 20 / healthOfRatingsCount) : 0;

        const endDate = metrics?.metrics?.endDate;
        const startDate = metrics?.metrics?.startDate;
        const journeyDays = metrics?.metrics?.programDuration;
        let journeyMinutes = metrics?.metrics?.journeyMinutes;

        journeyMinutes = journeyMinutes + minsToBeAdded;


        if (endDate && startDate) {
          const endDateObj = moment(endDate, 'DD-MM-YYYY');
          const startDateObj = moment(startDate, 'DD-MM-YYYY');

          let diffDays = endDateObj.diff(moment(), 'days');

          diffDays = diffDays > 0 ? moment().diff(startDateObj, 'days') : journeyDays;

          const denom = journeyMinutes * (diffDays / journeyDays) * learnerCount;
          let numerator = 0;
          this.learners.map((l) => {
            numerator = numerator + (l.progress * journeyMinutes);
          });

          this.engagementHealth = denom > 0 ? Math.ceil(numerator / denom) : 0;
          this.totalHours = Math.round(journeyMinutes / 60);

        }



      }
      const date = metrics?.metrics?.startDate;
      if (date !== undefined) {
      const endDateObj = moment();
      const startDateObj = moment(date, 'DD-MM-YYYY');

      const diffDays = endDateObj.diff(startDateObj, 'days');

      if (diffDays <= 7) {
        this.engagmentDataPoints = false;
      }
    }

      if (this.scoresHealth <= 33.33) {
      this.scoreHealthColor = '#ED6B4D';
    } else if (this.scoresHealth > 33.33 && this.scoresHealth <= 66.66) {
      this.scoreHealthColor = '#FFBD19';
    } else if (this.scoresHealth > 66.66) {
      this.scoreHealthColor = '#44A659';
    }
      if (this.ratingsHealth <= 40) {
      this.ratingHealthColor = '#ED6B4D';
    } else if (this.ratingsHealth > 40 && this.ratingsHealth <= 75) {
      this.ratingHealthColor = '#FFBD19';
    } else if (this.ratingsHealth > 75) {
      this.ratingHealthColor = '#44A659';
    }

      this.engagementHealthColor = '#E1E1E1';
      if (this.engagementHealth < 26 && this.engagementHealth > 0) {
      this.engagementHealthColor = '#ED6B4D';
    } else if (this.engagementHealth > 25 && this.engagementHealth < 51) {
      this.engagementHealthColor = '#FFBD19';
    } else if (this.engagementHealth > 50) {
      this.engagementHealthColor = '#44A659';
    }



    });


    this.store.select<string>('currentOrganization').pipe(distinctUntilChanged()).subscribe((organization) => {
      this.currentOrganization = organization;
    });

    this.store.select<string>('currentActivationTitle').pipe(distinctUntilChanged()).subscribe((activation) => {
      this.currentActivation = activation;
    });

    // Calculate overall progress, function present in partner.service.ts
    this.store.select<any>('elements').subscribe((elements) => {
        this.progress = this.partnerService.calculateOverallProgress(elements);
    });

    this.store.select<any>('learnerDetailMap').subscribe((elements)=>{
      // tslint:disable-next-line:forin
        for (const learner in elements){
          this.avgTimeSpent.totalTime += (elements[learner]?.timeSpent ? elements[learner]?.timeSpent : 0) + ( elements[learner]?.attendeLiveDuration ? elements[learner].attendeLiveDuration : 0);
          this.avgTimeSpent.count++;
        }
        this.learnerMap = elements;
    });
  }

  convertMasterClassTime(time, zone){
    const d = new Date(parseInt(time));
    const inititalDate = new Date(d.setUTCMinutes(d.getUTCMinutes() + d.getTimezoneOffset()));
    return new Date(inititalDate.setUTCMinutes(inititalDate.getUTCMinutes() + this.convertMinutes(zone))).getTime().toString();
  }

  convertUnlockDateTimeString(time){
    return new Date(parseInt(time)).toLocaleDateString('en', { year: 'numeric', month: 'short' , day: '2-digit' , hour: '2-digit', minute: '2-digit'});
  }

  convertMinutes(time){
    const timeParts = time.split(':');
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }

  onSortChange(sortCriteria: string, selected: string) {
    this.filteredUsers = this.filteredUsers ? this.filteredUsers.sort(this.sortCriteriaMap[sortCriteria]) : [];
    this.selectedValue = selected;
    if (sortCriteria === 'COMPLETION_HIGH_TO_LOW'){
      this.filteredUsers = this.filteredUsers ? this.filteredUsers.sort((a, b) => (b.progress - a.progress || a.completedon - b.completedon)) : [];
    }
    if (sortCriteria === 'COMPLETION_LOW_TO_HIGH'){
      this.filteredUsers = this.filteredUsers ? this.filteredUsers.sort((a, b) => (a.progress - b.progress || a.completedon - b.completedon)) : [];
    }
  }


  downloadReport = () => {

    const headers = ['Learner\'s Name', 'Last Login', 'Completion', 'Program Score', 'Email', 'Time Spent'];
    console.log(this.learnerMap);
    const data = this.filteredUsers.map((l) => {
      console.log(this.learnerMap[l.email]);
      return { 'Learner\'s Name': l.name,
        'Last Login': l.daysSinceLogin < 0 ? 'Never Logged in' : l.daysSinceLogin + ' days ago',
        Completion: l.progress, 'Program Score' : l.programpercentage > 0 ? l.programpercentage : 'NA',
        Email: l.email,
        'Time Spent': this.formatSec(parseFloat(this.learnerMap[l.email]?.timeSpent ? this.learnerMap[l.email].timeSpent : 0 ) + parseFloat(this.learnerMap[l.email]?.attendeLiveDuration ? this.learnerMap[l.email]?.attendeLiveDuration : 0))
      }
    });

    const filename = `Harappa | ${this.currentOrganization} | ${this.currentActivation} | Overall Leaderboard`;
    // this.partnerService.downloadFile(data, headers, filename);
    this.partnerService.downloadXlsx(data, filename);
  }



  getLongDateStringWithoutTime(dateNode) {

    if (dateNode) {

      const date = parseInt(dateNode);
      if (isNaN(date)){
        return dateNode ? dateNode : '-';
      }
      return moment.utc(dateNode).format('DD MMM YYYY');
    }
    else {
      return '-';
    }
  }


  isInt(intNode){
    const i = parseInt(intNode);
    if (isNaN(i)){
       return false;
    }
    return true;
  }

  downloadProgramReport = () => {

    const headers = ['Element Name', 'Element Type', 'Avg. Rating', 'Avg Score./Total Attendance', 'Description', 'Completed', 'In Progress', 'Not Started'];
    const data = this.elements.map((l) => ({ 'Element Name': l.title, 'Element Type': l.type,
      'Avg. Rating': l.avgRating,
      Description: l.description,
      'Total Attendance' : l.type === 'MASTERCLASS' ? (l.completed > 0 ? l.completed : 'NA') : '',
      'Avg. Score': l.type !== 'MASTERCLASS' ? l.avgScore : '',
      Completed : l.completed, 'In Progress': l.inProgress, 'Not Started' : l.notStarted

    }));

    const filename = `Harappa | ${this.currentOrganization} | ${this.currentActivation} | Program Elements`;
    // this.partnerService.downloadFile(data, headers, filename);
    this.partnerService.downloadXlsx(data, filename);

  }



  takeAwaysFilter(learners: any) {
    return learners ? learners.filter((l) => l.threekeytakeaways) : [];
  }

  takeawaysToggle() {
    this.openDiv = this.openDiv === 'out' ? 'in' : 'out';
  }

  selectValue(name) {
    this.selectedValue = name;
  }
  formatSec(d){
    if (!d || Math.floor(d / 60) == 0){
      return '-';
    }
    const minString = Math.floor(d / 60) % 60 > 9 ? `${Math.floor(d / 60) % 60} mins` : `${Math.floor(d / 60) % 60} min`;
    return Math.floor(d / 3600) > 0 ? `${Math.floor(d / 3600)} h ` + minString : minString;
  }
  filterUsers() {
    const filteredMap = new Map();
    this.learners.forEach(user => {
      const key = `${user.firstName}_${user.lastName}_${user.email}`;
      if (!filteredMap.has(key) || filteredMap.get(key).progress < user.progress) {
        filteredMap.set(key, user);
      }
    });
    this.filteredUsers = Array.from(filteredMap.values());
  }
  protected readonly Math = Math;
}


